import { Map as ImmutableMap } from 'immutable';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isLoading, isFailed } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';

// @ts-expect-error module not typed

import { getDirectReplies
// @ts-expect-error module not typed
} from 'conversations-message-history/thread-history/operators/getters';
import { getGenericChannelId, getSenders } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getDirectReplyToMessageId, getStatusForCmf, getTimestamp, getPlainText
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAttachments } from 'conversations-message-history/common-message-format/operators/getAttachments';
// @ts-expect-error module not typed
import { getAttachmentsForMessage } from 'conversations-message-history/message-history/operators/getAttachmentsForMessage';
import DirectReply from 'conversations-message-history/thread-history/records/DirectReply';
import { useCommonMessageWithId } from 'conversations-thread-data/thread-history/public/hooks';
import { directReplyReceived } from 'conversations-thread-data/thread-view-realtime/public/actions/directReplyReceived';
import { getAsyncAttachmentState } from 'conversations-inbox-message-history/attachments/operators/getAsyncAttachmentState';
import { useFriendlyNameForMessage } from '../../thread-history/hooks/useFriendlyNameForMessage';
import { FriendlySenderName } from 'conversations-inbox-message-history/senders/components/FriendlySenderName';
import { jsx as _jsx } from "react/jsx-runtime";
const createDirectReplyFromMessage = message => {
  return DirectReply({
    attachments: getAttachments(message),
    genericChannelId: getGenericChannelId(message),
    messageStatus: getStatusForCmf(message),
    messageTimestamp: getTimestamp(message),
    senders: getSenders(message),
    truncatedText: getPlainText(message)
  });
};
export const useDirectReplyMessage = ({
  fileAttachmentsForThread,
  friendlyNames,
  indexedAsyncFileAttachments,
  message,
  threadHistory,
  threadId,
  vid
}) => {
  const dispatch = useDispatch();
  const originalMessageId = getDirectReplyToMessageId(message);
  const loadedDirectReplies = getDirectReplies(threadHistory);
  const loadedDirectReply = loadedDirectReplies ? loadedDirectReplies.get(originalMessageId) : null;
  const {
    asyncCommonMessage
  } = useCommonMessageWithId({
    deferred: Boolean(!originalMessageId || loadedDirectReply),
    messageId: originalMessageId,
    threadHistory,
    threadId
  });
  const originalMessage = getData(asyncCommonMessage);
  const directReply = loadedDirectReply || (originalMessage ? createDirectReplyFromMessage(originalMessage) : null);
  const {
    friendlyName: senderName,
    isNamedUnknownVisitor,
    isLoading: isSenderNameLoading
  } = useFriendlyNameForMessage({
    friendlyNames,
    message: directReply,
    threadId,
    vid
  });
  useEffect(() => {
    if (!loadedDirectReply && directReply) {
      const newDirectReplies = ImmutableMap({
        [originalMessageId]: directReply
      });
      dispatch(directReplyReceived({
        newDirectReplies,
        threadId
      }));
    }
  }, [directReply, dispatch, loadedDirectReply, originalMessageId, threadId]);
  const attachmentsForDirectReply = getAttachmentsForMessage(directReply, fileAttachmentsForThread);
  const asyncAttachmentState = fileAttachmentsForThread && indexedAsyncFileAttachments && getAsyncAttachmentState({
    message: directReply,
    loadedFileAttachments: fileAttachmentsForThread,
    indexedAsyncFileAttachments
  });
  const isLoadingFileAttachment = asyncAttachmentState && asyncAttachmentState.isLoadingAttachment;
  const isMissingAttachment = asyncAttachmentState && asyncAttachmentState.isMissingAttachment;
  const isLoadingOriginalMessage = !loadedDirectReply && isLoading(asyncCommonMessage);
  return originalMessageId ? {
    directReply,
    isFailed: !loadedDirectReply ? isFailed(asyncCommonMessage) : false,
    isLoading: isLoadingOriginalMessage || isLoadingFileAttachment,
    isMissingFileAttachment: isMissingAttachment,
    resolvedFileAttachments: attachmentsForDirectReply,
    senderName: /*#__PURE__*/_jsx(FriendlySenderName, {
      senderName: senderName,
      isNamedUnknownVisitor: isNamedUnknownVisitor,
      isLoading: isSenderNameLoading
    }),
    threadId,
    messageId: originalMessageId
  } : null;
};
export const withDirectReplyToMessage = Component => {
  const ComponentWithDirectReplyToMessage = props => {
    const {
      fileAttachmentsForThread,
      friendlyNames,
      indexedAsyncFileAttachments,
      message,
      threadHistory,
      threadId,
      vid
    } = props;
    const directReplyState = useDirectReplyMessage({
      fileAttachmentsForThread,
      friendlyNames,
      indexedAsyncFileAttachments,
      message,
      threadHistory,
      threadId,
      vid
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      directReplyState: directReplyState
    }));
  };
  ComponentWithDirectReplyToMessage.displayName = `withDirectReplyToMessage(${Component.displayName})`;
  return ComponentWithDirectReplyToMessage;
};